module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/lpo_case_01-a9044ee4db1905479d8588dd610f94a3.png";